export const version = "strings/5.4.0";
//# sourceMappingURL=_version.js.map